// @flow

import type {Language, Notification} from '@/types'

import React, {Component} from 'react'
import {map} from 'ramda'

import GoCloudDownload from 'react-icons/lib/go/cloud-download'
import GoCloudUpload from 'react-icons/lib/go/cloud-upload'
import GoInbox from 'react-icons/lib/go/inbox'
import GoMail from 'react-icons/lib/go/mail'
import GoSync from 'react-icons/lib/go/sync'
import MdCloudOff from 'react-icons/lib/md/cloud-off'

import {date} from '@/format'
import './notifications.css'

import styled from 'styled-components'
import {selectThemeColours} from '@/theme-colours'
import {getSessionPartnerId} from '@/partnerID'

type Props = {
  notifications: Array<Notification>,
  l: Language,
  langCode: string,
}

const Button = styled.button`
  background-color: ${(props) => props.themeColours.primaryColour};
  border-color: ${(props) => props.themeColours.primaryColour};

  &:hover {
    background-color: ${(props) => props.themeColours.secondaryColour};
    border-color: ${(props) => props.themeColours.secondaryColour};
  }
  &:focus {
    background-color: ${(props) => props.themeColours.secondaryColour};
    border-color: ${(props) => props.themeColours.secondaryColour};
  }
`

const renderIcon = (type: number, count: number, buttonColour: string) => {
  const size = 32
  switch (type) {
    case 1: return <GoCloudUpload size={size} color={buttonColour} />
    case 2: return <GoSync size={size} color={buttonColour} />
    case 3: return count === 0 ? <MdCloudOff size={size} color={buttonColour} /> : <GoCloudDownload size={size} color={buttonColour} />
    case 4: return <GoInbox size={size} color={buttonColour} />
    default: return null
  }
}

const buildSummary = (l, n) => {
  const isOne = n.numberOfItems === 1
  switch (n.notificationType) {
    case 1: return n.numberOfItems + ' ' + l(`${isOne ? 'company' : 'companies'} imported`)
    case 2: return n.numberOfItems + ' ' + l(`${isOne ? 'company' : 'companies'} synchronized`)
    case 3: return n.numberOfItems + ' ' + l(`row${isOne ? '' : 's'} exported`)
    case 4: return n.numberOfItems + ' ' + l(`company alert${isOne ? '' : 's'}`)
    default: return ''
  }
}

const buildHeader = (n, l) => {
  const summaryArray = (n.summary.split('-')).map((v) => v.trim())
  const updatedSummary = summaryArray.splice(1, summaryArray.length - 1).join(' - ')
  const displayedSummary = updatedSummary ? ' - ' + updatedSummary : ''
  switch (n.notificationType) {
    case 1: return l('File Import') + displayedSummary
    case 2: return l('File Sync') + displayedSummary
    case 3: return l('File Export') + displayedSummary
    case 4: return l('Notification Alert') + displayedSummary
    default: return displayedSummary
  }
}

const renderRow = (l: Language, langCode: string, buttonColour: string) => (notification: Notification) =>
  <div className="media" key={notification.notificationId}>
    <div className="media-left">
      {renderIcon(notification.notificationType, notification.numberOfItems, buttonColour)}
    </div>
    <div className="media-body">
      <h6 className="media-heading">
        {buildHeader(notification, l)}
      </h6>
      <div className="media-details">
        <div className='col-md-7' title={buildSummary(l, notification)}>{buildSummary(l, notification)}</div>
        <div className='pull-right'>{notification.createdDate && date(notification.createdDate, langCode)}</div>
      </div>
    </div>
  </div>

const renderRows = (l, langCode, buttonColour) => map(renderRow(l, langCode, buttonColour))

class RawNotifications extends Component<Props, *> {
  constructor (props: Props) {
    super(props)

    this.state = {
      listShown: false,
    }
  }

  render () {
    const themeColour = selectThemeColours(getSessionPartnerId())
    return (
      <div className='notifications-ctr'>
        <Button id="notifications_sent"
          type="button"
          themeColours={themeColour}
          className="btn btn-danger notification-btn"
          onClick={() => {
            this.setState((prevState) => ({
              listShown: !prevState.listShown,
            }))
          }}
          onBlur={() => {
            this.setState({
              listShown: false,
            })
          }}
        >
          <GoMail /> {this.props.l('Notifications sent')}
        </Button>
        <div
          style={{display: this.state.listShown ? 'block' : 'none'}}
          className={(this.props.notifications && this.props.notifications.length > 5) ? 'notification-list notification-list-vertical-scroll' : 'notification-list'}
        >
          {(this.props.notifications && this.props.notifications.length > 0)
            ? renderRows(this.props.l, this.props.langCode, themeColour.primaryColour)(this.props.notifications)
            : this.props.l('There are no notifications')
          }
        </div>
      </div>
    )
  }
}

export default RawNotifications



// WEBPACK FOOTER //
// ./src/views/header/notifications.js